// extracted by mini-css-extract-plugin
export default {"main":"App_main__+D369","logo":"App_logo__DpY9C","logoImage":"App_logoImage__TRSSQ","links":"App_links__yvp75","attribution":"App_attribution__FnqnY"};